export default [
  {
    meta: {
      icon: "iconfont iconjichuxinxiguanli",
      title: "梧桐经销商管理",
      uri: "/newRetail/wutongDistributor",
    },
    subMenus: [
      {
        meta: {
          icon: "iconfont iconxiaoshoushujuguanli",
          title: "店铺入驻审核",
          uri: "/newRetail/wutongDistributor/shopAudit",
        },
        component: () => import("./shopAudit/index.vue"),
        path: "/newRetail/wutongDistributor/shopAudit",
      },
    ],
  },
];

